import React from 'react';
import { getFormattedActualDate, getTimeExpression } from '../timeline-utils.js';
import './timeline-header.css';
function TimelineHeader(props) {
    const { intervals } = props;
    const today = getFormattedActualDate();
    return (React.createElement("div", { className: "c-timeline__header" },
        React.createElement("div", { className: "c-timeline__header-time" },
            React.createElement("span", { className: "c-timeline__header-time__text" }, today)),
        React.createElement("div", { className: "c-timeline__header-intervals" }, intervals.map((interval) => {
            const time = getTimeExpression(interval);
            return (React.createElement("div", { className: "c-timeline__header-interval", key: interval.toString() },
                React.createElement("span", { className: "c-timeline__header-interval__text" }, time),
                React.createElement("div", { className: "c-timeline__header-interval__large-tick" }),
                React.createElement("div", { className: "c-timeline__header-interval__small-tick" })));
        }))));
}
export { TimelineHeader, };
//# sourceMappingURL=timeline-header.js.map